'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('bcmModule')
    .factory('biaProfileService', ['$http', '$q', function ($http, $q) {
        var baseUrl = environment.apiUrl + '/Pilot/api/BIAProfile';
        var returnData = function (response) { return response.data; };

        return {

            // Get BIA Profile
            getBIAProfile: function (biaProfileId) {
                return $http
                        .get(baseUrl + '/' + biaProfileId)
                        .then(function (response) {
                            if (response.error) {
                                return $q.reject(response);
                            } else {
                                return response.data;
                            }
                        })
            },

            // Get BIA Profile Container
            getBIAProfileContainer: function (biaProfileId) {
                return $http
                        .get(baseUrl + '/' + biaProfileId + '/Container')
                        .then(function (response) { return response.data; })
            },

           // Get All BIA Profiles
           getAllBIAProfiles: function () {
                return $http
                        .get(baseUrl)
                        .then(function (response) {
                            if (response.error) {
                                return $q.reject(response);
                            } else {
                                return response.data;
                            }
                        })
            },

            // Create BIA Profile
            createBIAProfile: function (biaProfile) {
                return $http
                    .post(baseUrl, biaProfile)
                    .then(function (response) { return response.data; })
            },

            // Update BIA Profile
            updateBIAProfile: function (biaProfileId, biaProfile) {
                return $http
                    .put(baseUrl + '/' + biaProfileId, biaProfile)
                    .then(function (response) { return response.data; })
            },

            // Delete BIA Profile
            deleteBIAProfile: function (biaProfileId) {
                var reqUrl = baseUrl + '/' + biaProfileId;

                return $http
                        .delete(reqUrl)
                        .then(function (response) { return response.data; })
            },

            // Validate BIA Profile by Business Continuity Coordinator
            validateByCoordinator: function (biaProfileId) {
                return $http
                    .post(baseUrl + '/' + biaProfileId + '/Validate/For/Coordinator')
                    .then(returnData);
            },

            // Validate BIA Profile by BU Owner
            validateByBUOwner: function (biaProfileId) {
                return $http
                    .post(baseUrl + '/' + biaProfileId + '/BIABUOwner/Validate')
                    .then(returnData);
            },

            // Reject BIA Profile by BU Owner
            rejectByBUOwner: function (biaProfileId) {
                return $http
                    .post(baseUrl + '/' + biaProfileId + '/BIABUOwner/Reject')
                    .then(returnData);
            },

            // Reset BIA Profile Validation
            resetBIAProfileValidation: function (biaProfileId) {
                return $http
                    .post(baseUrl + '/' + biaProfileId + '/Reset')
                    .then(returnData);
            },

            // Create BIA Profile Followup
            createBIAProfileFollowUp: function (biaProfileId, followUp) {
                return $http
                    .post(baseUrl + '/' + biaProfileId + '/FollowUp', followUp)
                    .then(returnData);
            },

            // Get BIA Profile Followups
            getFollowUpListByBIAProfileID: function (biaProfileId, followUp) {
                return $http
                    .get(baseUrl + '/' + biaProfileId + '/FollowUp', followUp)
                    .then(returnData);
            },

            // Get Possible Responsabilities by Profile
            getPossibleResponsibilities: function (biaProfileId) {

                var reqUrl = baseUrl + '/' + biaProfileId + '/PossibleResponsibility';

                return $http
                        .get(reqUrl)
                        .then(function (response) {
                            if (response.error) {
                                return $q.reject(response);
                            } else {
                                return response.data;
                            }
                        })
            },

            // Get Possible Responsabilities For BU Owner
            getPossibleResponsibilitiesForBUOwner: function (biaProfileId, buOwnerId) {

                var reqUrl = baseUrl + '/' + biaProfileId + '/PossibleResponsibility/For/BuOwner/' + buOwnerId;

                return $http
                        .get(reqUrl)
                        .then(function (response) {
                            if (response.error) {
                                return $q.reject(response);
                            } else {
                                return response.data;
                            }
                        })
            },

            // Get BIA Profile Summary Container
            getBIASummaryContainer: function (biaProfileId) {
                return $http
                    .get(baseUrl + '/' + biaProfileId + '/Summary/Container')
                    .then(returnData);
            },

            // Get BIA Profile Criticality View
            getCriticalityView: function (biaProfileId) {
                return $http
                    .get(baseUrl + '/' + biaProfileId + '/CriticalityView')
                    .then(returnData);
            }
        };
    }]);
